module.exports = __webpack_public_path__ + "img/org-dark.d48ee973.svg";